import SnippetsBarComponent from './SnippetsBar';
import PersonalizedTextComponent from './PersonalizedText';

export const SnippetsBar = SnippetsBarComponent;
export const PersonalizedText = PersonalizedTextComponent;
